import React from 'react';
import { Communication } from '../../services/communicationService';
import { formatDateTime } from '../../utils/dateUtils';

interface Props {
  item: Communication;
  onClick: (item: Communication) => void;
  userTimezone: string;
}

const CommunicationTimelineItem: React.FC<Props> = ({ item, onClick, userTimezone }) => {
  const outgoing = item.direction === 'OUTGOING';
  const when = formatDateTime(item.received_at || item.created_at, {}, userTimezone);
  const preview = (item.body_text || '').replace(/\s+/g, ' ').trim();

  return (
    <div className={`flex ${outgoing ? 'justify-end' : 'justify-start'}`}>
      <button
        type="button"
        onClick={() => onClick(item)}
        className={`text-left w-full max-w-[90%] rounded-lg px-3 py-2 border-l-4 transition-colors break-words ${
          outgoing
            ? 'bg-[#EBF5F5] border-[#3A7380] hover:bg-[#D0E7E5]'
            : 'bg-white border-gray-400 hover:bg-gray-50'
        } border-y border-r border-gray-200`}
      >
        <div className="flex items-center justify-between gap-2 mb-1">
          <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-600">
            <span className="px-1.5 py-0.5 rounded bg-gray-200 text-gray-700">{item.channel}</span>
            <span>{outgoing ? '↗ Sent' : '↙ Received'}</span>
          </span>
          <span className="text-[11px] text-gray-400 whitespace-nowrap">{when}</span>
        </div>
        {item.channel === 'EMAIL' && (
          <div className="text-sm font-medium text-gray-900 truncate">
            {item.subject || '(no subject)'}
          </div>
        )}
        {preview && (
          <div className="text-xs text-gray-500 truncate">{preview}</div>
        )}
        {(item.status === 'FAILED' || item.status === 'UNMATCHED') && (
          <span className="inline-block mt-1 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-red-100 text-red-700">
            {item.status}
          </span>
        )}
      </button>
    </div>
  );
};

export default CommunicationTimelineItem;
